import { CompleteTrainingButtonController } from './complete-training-button.controller';
import { CompleteTrainingButtonProps } from './complete-training-button.model';

export const CompleteTrainingButton = (props: CompleteTrainingButtonProps) => {
  return <CompleteTrainingButtonController {...props} />;
};
